import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "col-md-4 text-center" }
const _hoisted_5 = { class: "col-md-4 text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/services",
          class: "btn btn-info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Back')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('New Service')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.saveService($data.service)))
        }, _toDisplayString(_ctx.$t('Save')), 1)
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('Description')), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.service.description) = $event))
      }, null, 512), [
        [_vModelText, $data.service.description]
      ])
    ])
  ]))
}